import type { RouteRecordRaw } from 'vue-router';

import { computed } from 'vue';

import { useAccountsStore } from '@abaninja/data-access-swiss21-users';
import { useGlobalI18n } from '@abaninja/util-i18n';

const { global: { t } } = useGlobalI18n();

export const routes: RouteRecordRaw[] = [
  {
    path: 'onboarding',
    beforeEnter: () => {
      const { entities } = useAccountsStore();

      if (entities.value.length) {
        return { name: 'dashboard' };
      }

      return true;
    },
    children: [
      {
        name: 'onboarding',
        path: '',
        component: () => import('../OnboardingIndex.vue'),
        meta: {
          title: computed(() => t('messages.companyOverview')),
        },
      },
      {
        name: 'onboarding-setup',
        path: 'setup',
        component: () => import('../OnboardingSetup.vue'),
        meta: {
          title: computed(() => t('messages.onboarding')),
        },
      },
    ],
  },
  {
    name: 'accept-agb',
    path: 'accept-agb',
    component: () => import('../AcceptAgb.vue'),
    meta: {
      needsAccount: true,
      title: computed(() => t('messages.acceptAgb')),
    },
  },
];
